import { render, staticRenderFns } from "./baseSelectTagSearch.vue?vue&type=template&id=ac1818d2&scoped=true&"
import script from "./baseSelectTagSearch.vue?vue&type=script&lang=ts&"
export * from "./baseSelectTagSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1818d2",
  null
  
)

export default component.exports